import { Badge } from "@prismicio/editor-ui"

export function E2eReminder() {
  const repository = window.__repository__

  if (!repository) return null

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        zIndex: 99_999,
        bottom: 28,
        right: 80,
      }}
    >
      <Badge title={`E2E repo: ${repository}`} color="tomato" size="small" />
    </div>
  )
}
